import React, { Component } from "react";
import "./WallOfShame.css";

const galleryPromise = fetch("/.netlify/functions/gallery").then(res =>
  res.json()
);

const text = item => {
  const date = item.created_at.split("T")[0];
  return `${date} ${item.name}`;
};

function dataURItoBlob(dataURI) {
  if (typeof dataURI !== "string") {
    throw new Error("Invalid argument: dataURI must be a string");
  }
  dataURI = dataURI.split(",");
  var type = dataURI[0].split(":")[1].split(";")[0],
    byteString = atob(dataURI[1]),
    byteStringLength = byteString.length,
    arrayBuffer = new ArrayBuffer(byteStringLength),
    intArray = new Uint8Array(arrayBuffer);
  for (var i = 0; i < byteStringLength; i++) {
    intArray[i] = byteString.charCodeAt(i);
  }
  return new Blob([intArray], {
    type: type
  });
}

const classes = (...args) => args.filter(Boolean).join(" ");

const Image = props => (
  <div
    className={classes(
      "WallOfShame-item",
      props.isProspect && "WallOfShame-prospect"
    )}
  >
    <div className="WallOfShame--image-container" onClick={props.onClick}>
      {props.isProspect && (
        <a>
          <strong>Join the Club!</strong> Click to add your face to my wall of
          shame
        </a>
      )}
      <img src={props.image} alt="This could be you" />
    </div>
    <p>{text(props)}</p>
  </div>
);

export default class WallOfShame extends Component {
  state = {
    gallery: []
  };

  componentDidMount() {
    galleryPromise.then(gallery => this.setState({ gallery }));
    this.setState({
      wallOfShameProspect: JSON.parse(
        sessionStorage.getItem("wallOfShameProspect")
      )
    });
  }

  uploadProspect = () => {
    if (this.currentFetch) {
      return;
    }
    const { image, name } = this.state.wallOfShameProspect;
    const imageBlob = dataURItoBlob(image);
    const body = new FormData();
    body.append("form-name", "gallery");
    body.append("name", name);
    body.append("image", imageBlob);
    this.currentFetch = fetch(
      `https://www.princessworship.club/`,
      {
        method: "POST",
        body
      },
      "princess-worship-club.jpg"
    )
      .catch(e => {})
      .then(() => {
        sessionStorage.removeItem("wallOfShameProspect");
        // eslint-disable-next-line no-restricted-globals
        location.reload(true);
      });
  };

  render() {
    const prospect = this.state.wallOfShameProspect;

    return (
      <div className="WallOfShame">
        <h1>PRINCESS WORSHIP CLUB</h1>
        <div className="WallOfShame-gallery">
          {prospect && (
            <Image
              key={prospect.image}
              {...prospect}
              isProspect
              onClick={this.uploadProspect}
            />
          )}
          {this.state.gallery.map(item => <Image key={item.image} {...item} />)}
        </div>
        <h2>WALL OF SHAME</h2>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/WallOfShame/index.js